import { Employee, parseEmployee } from '../employee';
import { Invoice, parseInvoice } from '../invoice';

export class PrepaymentProposal {
  employee: Employee;
  contentType: string;
  objectId: string;
  invoice: Invoice;
  interestDelayed: number;
  interestDefault: number;
  fine: number;
  bankingChargeUrl: string;
  isDismissal: Invoice;

  constructor(data: any | PrepaymentProposal | DjangoPrepaymentProposal = {}) {
    if (data instanceof PrepaymentProposal) {
      bindPrepaymentProposalData(this, data);
    } else {
      bindDjangoPrepaymentProposalData(this, data);
    }
  }
}

export interface DjangoPrepaymentProposal {
  employee: Employee;
  content_type: string;
  object_id: string;
  invoice: Invoice;
  interest_delayed: number;
  interest_default: number;
  fine: number;
  banking_charge_url: string;
  is_dismissal: Invoice;
}

function bindPrepaymentProposalData(
  prepaymentProposal: PrepaymentProposal,
  data: PrepaymentProposal,
) {
  prepaymentProposal.employee = parseEmployee(data.employee);
  prepaymentProposal.contentType = data.contentType;
  prepaymentProposal.objectId = data.objectId;
  prepaymentProposal.invoice = parseInvoice(data.invoice);
  prepaymentProposal.interestDelayed = data.interestDelayed;
  prepaymentProposal.interestDefault = data.interestDefault;
  prepaymentProposal.fine = data.fine;
  prepaymentProposal.bankingChargeUrl = data.bankingChargeUrl;
  prepaymentProposal.isDismissal = data.isDismissal;
}

function bindDjangoPrepaymentProposalData(
  prepaymentProposal: PrepaymentProposal,
  data: DjangoPrepaymentProposal,
) {
  prepaymentProposal.employee = parseEmployee(data.employee);
  prepaymentProposal.contentType = data.content_type;
  prepaymentProposal.objectId = data.object_id;
  prepaymentProposal.invoice = parseInvoice(data.invoice);
  prepaymentProposal.interestDelayed = data.interest_delayed;
  prepaymentProposal.interestDefault = data.interest_default;
  prepaymentProposal.fine = data.fine;
  prepaymentProposal.bankingChargeUrl = data.banking_charge_url;
  prepaymentProposal.isDismissal = data.is_dismissal;
}
